module.exports = __webpack_public_path__ + "images/112b8248a7343ebfa0f89cf9942997a373.svg";